import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoMicrosoft = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_9963_62064)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M5.72784 5.72784H0.5V0.5H5.72784V5.72784Z",
					fill: "#F1511B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M11.5012 5.72784H6.27344V0.5H11.5012V5.72784Z",
					fill: "#80CC28"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M5.72771 11.5003H0.5V6.27246H5.72771V11.5003Z",
					fill: "#00ADEF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M11.5012 11.5003H6.27344V6.27246H11.5012V11.5003Z",
					fill: "#FBBC09"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_9963_62064",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 11,
				height: 11,
				fill: "white",
				transform: "translate(0.5 0.5)"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgLogoMicrosoft);
export { ForwardRef as ReactComponent };
